export default __webpack_public_path__ + "static/1-0a37773f5ea99db8a1fa128b28bc2ce3.png";